export const GLOBAL_LOAD = 'globalLoad';
export const SITE_SECTION = 'tools';
export const LANDING_PAGE_NAME = 'fpro:tools:incentive tool';
export const INCENTIVE_DETAILS_PAGE_NAME = 'fpro:tools:incentive tool:details';
export const LOGIN_STATUS_TRUE = 'logged in';
export const LOGIN_STATUS_FALSE = 'logged out';
export const FPRO_US = 'fpro-us';
export const FPG_COOKIES = 'fpg_cookies';
export const COOKIE_PREFERENCES = 'cookiePreferences';
